import { apiClient } from './client';

export async function getTenantSchemaOverview() {
  const { data } = await apiClient.get('/api/system/tenant-schema/overview');
  return data;
}

export async function getTenantSchemaVersions(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-schema/versions', { params });
  return data;
}

export async function createTenantSchemaVersion(payload) {
  const { data } = await apiClient.post('/api/system/tenant-schema/versions', payload);
  return data;
}

export async function registerTenantSchemaArtifacts(payload = {}) {
  const { data } = await apiClient.post('/api/system/tenant-schema/versions/register-artifacts', payload);
  return data;
}

export async function analyzeTenantSchemaBaseline(payload = {}) {
  const { data } = await apiClient.post('/api/system/tenant-schema/baseline/analyze', payload);
  return data;
}

export async function compileTenantSchemaBaseline(payload = {}) {
  const { data } = await apiClient.post('/api/system/tenant-schema/baseline/compile', payload);
  return data;
}

export async function getLatestTenantSchemaBaseline() {
  const { data } = await apiClient.get('/api/system/tenant-schema/baseline/latest');
  return data;
}

export async function updateTenantSchemaVersion(id, payload) {
  const { data } = await apiClient.put(`/api/system/tenant-schema/versions/${id}`, payload);
  return data;
}

export async function approveTenantSchemaVersion(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenant-schema/versions/${id}/approve`, payload);
  return data;
}

export async function deprecateTenantSchemaVersion(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenant-schema/versions/${id}/deprecate`, payload);
  return data;
}

export async function blockTenantSchemaVersion(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenant-schema/versions/${id}/block`, payload);
  return data;
}

export async function auditMafertAppMigrations(payload = {}) {
  const { data } = await apiClient.post('/api/system/tenant-schema/audit/mafertapp-migrations', payload);
  return data;
}

export async function getLatestMafertAppMigrationAudit() {
  const { data } = await apiClient.get('/api/system/tenant-schema/audit/latest');
  return data;
}

export async function getTenantSchemaArtifacts(versionId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenant-schema/versions/${versionId}/artifacts`, { params });
  return data;
}

export async function updateTenantSchemaArtifact(versionId, artifactId, payload) {
  const { data } = await apiClient.put(`/api/system/tenant-schema/versions/${versionId}/artifacts/${artifactId}`, payload);
  return data;
}

export async function bulkUpdateTenantSchemaArtifacts(versionId, payload) {
  const { data } = await apiClient.post(`/api/system/tenant-schema/versions/${versionId}/artifacts/bulk-update`, payload);
  return data;
}

export async function getTenantSchemaPlan(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/schema-plan`);
  return data;
}

export async function buildTenantSchemaPlan(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/schema-plan`, payload);
  return data;
}

export async function dryRunTenantSchemaPlan(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/schema-plan/dry-run`, payload);
  return data;
}

export async function approveTenantSchemaPlan(tenantId, planId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/schema-plan/${planId}/approve`, payload);
  return data;
}

export async function getTenantSchemaEvents(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/schema-events`, { params });
  return data;
}

export async function getTenantSchemaPlans(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-schema/plans', { params });
  return data;
}

export async function getTenantSchemaAllEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-schema/events', { params });
  return data;
}

export async function getPortalTenantSchemaStatus(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/schema-status`);
  return data;
}

export async function previewTenantSchemaRun(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/schema-runs/preview`, payload);
  return data;
}

export async function startTenantSchemaRun(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/schema-runs`, payload);
  return data;
}

export async function getTenantSchemaRuns(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/schema-runs`, { params });
  return data;
}

export async function getTenantSchemaRunById(runId) {
  const { data } = await apiClient.get(`/api/system/tenant-schema-runs/${runId}`);
  return data;
}

export async function getTenantSchemaRunMigrations(runId) {
  const { data } = await apiClient.get(`/api/system/tenant-schema-runs/${runId}/migrations`);
  return data;
}

export async function cancelTenantSchemaRun(tenantId, runId) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/schema-runs/${runId}/cancel`);
  return data;
}
